import { c as _c } from "react/compiler-runtime";
import type { ConfigInterface, NextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useProvider } from '@newfront-insurance/react-provision';
import { routes } from '../../bff/routes';
import type { GetAccountByUuidParams, GetAccountByUuidResponse } from '../../bff/types';
import { LayoutConfigProvider } from '../config';
export function useAccountByUuid(params, config) {
  const $ = _c(3);
  const {
    apiBasePath: basePath
  } = useProvider(LayoutConfigProvider);
  let t0;
  if ($[0] !== basePath || $[1] !== params) {
    t0 = routes.getAccountByUuid.getUrl({
      params,
      basePath
    });
    $[0] = basePath;
    $[1] = params;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useNextApiSubscription(t0, config);
}